import React from "react";
import LegalPage from "./LegalPage";

const SECTIONS = [
  {
    heading: "Introduction",
    body:
      "Verified Workforce (\"we\", \"us\", \"our\") respects your privacy. This policy explains how we collect, use and protect information you provide when using our website and services.",
  },
  {
    heading: "Information we collect",
    body:
      "We collect information you submit through our enquiry and subcontractor registration forms, including your name, company, email, phone number and details of the project or trade you provide.",
  },
  {
    heading: "How we use your information",
    body:
      "We use your information solely to respond to your enquiry, match you with vetted subcontractors (or opportunities), and manage our trusted supply chain. We do not sell your data to third parties.",
  },
  {
    heading: "Data retention",
    body:
      "We retain enquiry and registration data for as long as it is needed to provide our services or to comply with legal obligations.",
  },
  {
    heading: "Your rights",
    body:
      "You may request access to, correction of, or deletion of your personal data at any time by emailing Robert@verifiedworkforce.co.uk.",
  },
  {
    heading: "Contact",
    body:
      "Questions about this Privacy Policy can be sent to Robert@verifiedworkforce.co.uk.",
  },
];

export default function Privacy() {
  return <LegalPage title="Privacy Policy" sections={SECTIONS} />;
}
